module.exports = __webpack_public_path__ + "static/media/blog.d4ce8622.svg";